import React, { useEffect, useState } from "react";
import { createPortal } from "react-dom";
import { X } from "lucide-react";

const HISTORIA = "/roge-historia.jpg";

function HistoriaModal({ onClose }) {
  const [falla, setFalla] = useState(false);
  useEffect(() => {
    const esc = (e) => { if (e.key === "Escape") onClose(); };
    document.addEventListener("keydown", esc);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => { document.removeEventListener("keydown", esc); document.body.style.overflow = prev; };
  }, [onClose]);
  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center p-2 sm:p-6" role="dialog" aria-modal="true" aria-label="¿Por qué Roge?" data-testid="roge-historia-modal">
      <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" onClick={onClose} />
      <div className="relative z-10 flex max-h-full w-full max-w-6xl flex-col overflow-hidden rounded-2xl bg-white shadow-2xl animate-fade-in-up">
        <button onClick={onClose} data-testid="roge-historia-cerrar" aria-label="Cerrar"
          className="absolute right-2 top-2 z-10 flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-slate-700 shadow-md hover:bg-white hover:text-vino-700">
          <X className="h-5 w-5" />
        </button>
        <div className="overflow-auto">
          {falla
            ? <p className="p-10 text-center text-sm text-slate-500" data-testid="roge-historia-pendiente">La infografía «¿Por qué Roge?» aún no está cargada.</p>
            : <img src={HISTORIA} alt="¿Por qué Roge? La historia real de nuestro gato rescatado por Human" onError={() => setFalla(true)} data-testid="roge-historia-img" className="block h-auto w-full min-w-[640px] sm:min-w-0" />}
        </div>
      </div>
    </div>,
    document.body,
  );
}

const Flecha = () => (
  <svg viewBox="0 0 60 44" className="pointer-events-none absolute -left-4 bottom-0 h-6 w-8" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" aria-hidden="true">
    <path d="M52 6 C 50 26, 34 36, 10 36" />
    <path d="M18 28 L 9 36 L 18 42" />
  </svg>
);

const Destellos = () => (
  <svg viewBox="0 0 40 40" className="pointer-events-none absolute -right-3 -top-4 h-5 w-5" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
    <path d="M8 22 L 10 10" /><path d="M18 20 L 26 6" /><path d="M24 28 L 36 22" />
  </svg>
);

export function RogeSoyYo() {
  const [open, setOpen] = useState(false);
  return (
    <>
      <button type="button" onClick={() => setOpen(true)} data-testid="btn-roge-soy-yo" title="Conoce la historia de Roge"
        className="group absolute -right-11 bottom-1 pl-3 text-white transition-transform duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-white/60 rounded">
        <Destellos />
        <span className="block font-hand text-[17px] font-bold leading-[0.95] drop-shadow-sm">Roge<br /><span className="pl-2">soy yo</span></span>
        <Flecha />
        <svg viewBox="0 0 20 12" className="pointer-events-none absolute -bottom-2 right-1 h-2.5 w-4 text-vino-300" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true"><path d="M4 2 L 6 10" /><path d="M12 2 L 13 9" /></svg>
      </button>
      {open && <HistoriaModal onClose={() => setOpen(false)} />}
    </>
  );
}
